import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import { FileIcon } from './FileIcon';
import { IoClose } from "react-icons/io5";

export const FileStyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    color: '#fff',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    minHeight: 48,
    maxWidth: 280,
    minWidth: 120,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    backgroundColor: '#272822',
    '&.Mui-selected': {
      color: '#fff',
    },
    '&:focus': {
      opacity: 1,
    },
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    overflow: "hidden",
  },
  labelIcon: {
    minHeight: 48,
    paddingTop: 0,
  },
}))(({label, changed, onClose, type, method, templateType, ...props}) => {
  const handleClose = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onClose && onClose();
  };
  const finalLabel = (
    <span style={{ display: "inline-flex", alignItems: "center", width: "100%", minWidth: 0 }}>
      <FileIcon
        type={type}
        method={method}
        templateType={templateType}
        style={{ marginRight: 8, width: 18, height: 18, flexShrink: 0 }}
      />
      <span
        style={{
          flex: 1,
          minWidth: 0,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {changed ? `${label} *` : label}
      </span>
      <IoClose
        onClick={handleClose}
        onMouseDown={(event) => event.stopPropagation()}
        style={{ marginLeft: 8, width: 18, height: 18, cursor: "pointer", color: "#d1d5db", flexShrink: 0 }}
      />
    </span>
  );
  return <Tab disableRipple label={finalLabel} {...props}/>;
});
